export default __webpack_public_path__ + "img/57f061878dc39517f6ed0c0235571d02.png";